"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.TelemetrySpec = exports.ReactionsSpec = exports.LoyaltyProgramsSpec = exports.ConsumableSubsetsSpec = exports.ConsumablesSpec = exports.ConfigsSpec = exports.CommandsSpec = exports.AlarmsSpec = exports.NAMESPACE = void 0;
const Device = __importStar(require("../../../../../device"));
const User = __importStar(require("../../../../../user"));
const Common = __importStar(require("../common"));
const Catalog = __importStar(require("./catalog"));
const System = __importStar(require("./schema"));
exports.NAMESPACE = 'Culligan.Api.V2.Spec.Legacy.System.Spec';
/*
 * `routes/v2/api/system/<name>/router.js`, one group per router. Brands has
 * more routes than a catalogue and lives in `./brands`.
 */
exports.AlarmsSpec = Catalog.group({
    id: 'v2.system.alarms',
    prefix: '/system/alarms',
    kind: 'Alarm',
    subject: 'alarm',
    title: 'System Alarms',
    description: 'Catalogue of the alarms and alerts device models may raise',
    item: System.Alarm,
    notFound: { message: 'Alarm not found' },
    unique: 'id-and-name',
    protocol: 'v1',
});
exports.CommandsSpec = Catalog.group({
    id: 'v2.system.commands',
    prefix: '/system/commands',
    kind: 'Command',
    subject: 'command',
    title: 'System Commands',
    description: 'Catalogue of the commands device models accept or emit',
    item: System.Command,
    notFound: { message: 'Command not found' },
    unique: 'id-and-name',
    protocol: 'v1',
});
exports.ConfigsSpec = Catalog.group({
    id: 'v2.system.configs',
    prefix: '/system/configs',
    kind: 'Config',
    subject: 'config',
    title: 'System Configs',
    description: 'Catalogue of the configuration parameters device models expose',
    item: System.Config,
    notFound: { message: 'Config not found' },
    unique: 'id-and-name',
    protocol: 'v1',
});
exports.ConsumablesSpec = Catalog.group({
    id: 'v2.system.consumables',
    prefix: '/system/consumables',
    kind: 'Consumable',
    subject: 'consumable',
    title: 'System Consumables',
    description: 'Catalogue of the consumable definitions, in the legacy document shape. Derived from the domain at startup; read-only.',
    item: System.Consumable,
    notFound: { message: 'Consumable not found' },
    unique: 'id-and-name',
    protocol: 'v2',
    uniqueProtocol: 'v1',
});
exports.ConsumableSubsetsSpec = Catalog.group({
    id: 'v2.system.consumableSubsets',
    prefix: '/system/consumableSubsets',
    kind: 'ConsumableSubset',
    subject: 'consumable subset',
    title: 'System Consumable Subsets',
    description: 'Catalogue of the consumable definitions as the domain models them (filters, CO2 tanks, enhancements, UV lamps). `list` is open to every `read` role.',
    item: Device.Capability.Consumable.Definition.Definition,
    notFound: { message: 'Consumable subset not found' },
    unique: 'id-and-name',
    protocol: 'v2',
    listGuard: Common.withReadGuard,
});
exports.LoyaltyProgramsSpec = Catalog.group({
    id: 'v2.system.loyalty-programs',
    prefix: '/system/loyalty-programs',
    kind: 'LoyaltyProgram',
    subject: 'loyalty program',
    title: 'System Loyalty Programs',
    description: 'Catalogue of the loyalty programs users may subscribe to',
    item: User.Loyalty.LoyaltyProgram,
    notFound: { message: 'Loyalty program not found' },
    unique: 'id-and-name',
    protocol: 'v2',
});
exports.ReactionsSpec = Catalog.group({
    id: 'v2.system.reactions',
    prefix: '/system/reactions',
    kind: 'Reaction',
    subject: 'reaction',
    title: 'System Reactions',
    description: 'Catalogue of the notification channel definitions',
    item: System.Reaction,
    notFound: {
        quirk: 'an unknown id answers a v1 500, not the 404 the controller intends, because it reads the reaction with `get()`, which throws, instead of `tryGet()`.',
    },
    unique: 'name',
    protocol: 'v1',
});
exports.TelemetrySpec = Catalog.group({
    id: 'v2.system.telemetry',
    prefix: '/system/telemetry',
    kind: 'Telemetry',
    plural: 'Telemetry',
    subject: 'telemetry',
    title: 'System Telemetry',
    description: 'Catalogue of the telemetry device models report',
    item: System.Telemetry,
    notFound: { message: 'Telemetry not found' },
    unique: 'id-and-name',
    protocol: 'v1',
});
//# sourceMappingURL=spec.js.map